$(function() {
  //デバイスの高さを反映
  var windowHeight = $(window).height();
  $(".top-hero__inner").css("height", windowHeight);
});